<template>
  <el-select v-model="lan" placeholder="" class="select" @change="selectChang">
    <el-option v-for="item in lans" :key="item.value" :label="item.label" :value="item.value" />
  </el-select>
</template>
<script setup>
import { useState } from "@/hooks";
import verConfig from "@/utils/config";
import { lans, getLanguage, setLanguage, t } from "@/lang"
import { nextTick, onMounted } from "vue";

const [lan, setLan] = useState(verConfig.lang);

const selectChang = (val) => {
  if(val == getLanguage()) return;
  setLanguage(val)
  window.location.reload();
}

onMounted(() => {
  const _lan = getLanguage();
  const findIndex = lans.findIndex(item => item.value == _lan);
  if (findIndex < 0) {
    selectChang(verConfig.lang);
    setLan(verConfig.lang);
    return;
  }
  setLan(_lan || verConfig.lang);
})
</script>
<style lang="scss" scoped>
.select {
  min-width: 100px;
  border-radius: 8px;
  overflow: hidden;
  margin-left: 12px;

  ::v-deep .el-select__wrapper {
    background-color: $login_btn;
    box-shadow: none;

    .el-select__placeholder {
      color: $white;
    }

    .el-select__icon {
      color: $white
    }

  }

  ::v-deep .el-select__wrapper.is-hovering:not(.is-focused) {
    box-shadow: none !important;
  }
}
</style>